import styled, { css } from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const TitleContainer = styled.div<{
  isLiveTv?: boolean;
}>`
  @media screen and ${breakpoints.tablet.min.sm} {
    ${({ theme, isLiveTv }) =>
      isLiveTv &&
      css`
        margin-top: ${theme.space["space-2"]};
      `}
  }
`;

export const FlagContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  height: 20px;
  width: 20px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: ${({ theme }) => theme.space["space-2"]};

  & > svg {
    height: 18px;
    width: auto;
    flex-shrink: 0;
  }

  &:is(:empty) {
    display: none;
  }
`;
